<!-- eslint-disable vue/no-template-shadow -->
<!-- eslint-disable vue/no-mutating-props -->
<template>
    <tr v-if="data" class="pl5">
        <td>{{ index + 1 }}</td>
        <td>
            <ui-select :data-ui="'sales-table-select-parcel-type-' + data.id" v-model="data.parcel_type" :clearable="false" @input="parcelTypeHandler">
                <option v-for="(type, index) in parcelTypeOptionsComputed" :key="index" :value="type.value" :selected="type.value === data.parcel_type">
                    {{ type.display_name }}
                </option>
            </ui-select>
        </td>
		<td v-if="simulationType !== 'vertical'">
            <ui-select :data-ui="'sales-table-select-interest-' + data.id" v-model="data.interest" :disabled="!interestAllowed.includes(data.parcel_type)" :clearable="false" @input="interestHandler">
                <option v-for="(interest, index) in interestOptions" :key="index" :value="interest.value" :selected="interest.value === data.interest">
                    {{ interest.label }}
                </option>
            </ui-select>
        </td>
        <td>
            <ui-input-number :data-ui="'sales-table-input-quota-' + data.id" v-model="data.quota" :max-value="maxQuotaComputed" required size="md" />
        </td>
        <td>
            <ui-datepicker :data-ui="'sales-table-input-start-date-' + data.id" v-model="data.due_date" day-mode position-fixed />
        </td>
        <td>
            <ui-input :data-ui="'sales-table-input-percent-' + data.id" v-model="percentComputed" :disabled="disabled || data.parcel_type === 'fixed_value'" type="tel" group="%" percent />
        </td>
        <td>
            <ui-input-money  :data-ui="'sales-table-input-pmt-' + data.id"v-model="pmtComputed" :disabled="disabled" v-bind="moneyConfig" prefix='' group type="tel" />
        </td>
		<td v-if="$mx_userIsAdmin">
			<div class="readjustment-installments-select">
				<ui-select-v2
					:data-ui="'sales-table-select-readjustment-' + data.id"
					:data="readjustmentOptions"
					return-value="value"
					:placeholder="'Selecione'"
					:search="false"
					v-model="data.type_readjust"
					size="md"
					:min-width="'150px'"
					align="right"
					:show-footer="false"
					:margin-botton="false"
				/>
			</div>
		</td>
        <td>
            <ui-menu-card>
                <ui-button type="button" @click="removeItem()" :data-ui="'sales-table-button-remove-series-' + data.id" >Excluir</ui-button>
            </ui-menu-card>
        </td>
    </tr>
</template>

<script>
import { uiMenuCard } from '@/components/ui'
import { uiButton } from '@/components/ui/buttons'
import {
	uiDatepicker,
	uiInput,
	uiInputMoney,
	uiInputNumber,
	uiSelect,
	uiSelectV2
} from '@/components/ui/form'

import { salesTable } from '@/services/axios'

import { currencyBRL } from '@/filters'
import calculations from '@/mixins/calculations/salesTable'
import helpers from '@/mixins/helpers'
import {  permissionsMixin } from '@/mixins'

import { mapGetters } from 'vuex'
import { storage } from '@/services/storage'

const assert = require('assert')

export default {
	name: 'ui-sales-table-item',

	filters: {
		currencyBRL,
	},

	components: {
		uiButton,
		uiInput,
		uiSelect,
		uiSelectV2,
		uiDatepicker,
		uiInputMoney,
		uiMenuCard,
		uiInputNumber
	},

	mixins: [
		helpers,
		calculations,
		permissionsMixin
	],

	props: {
		data: {
			type: Object,
			required: true,
			default () {
				return {
					id: null,
					name: '',
					percent: '',
					parcel_type: null,
					interest: 'without',
					quota: '',
					data: null,
					sales_table_flow_id: null,
					deleted_at: null,
					due_date: 0,
					type_readjust: null,
					pmt: '',
				}
			}
		},
		form: {
			type: Object,
			required: true
		},
		flow: {
			type: Object,
			required: true
		},
		index: {
			type: Number,
			required: true
		},
		// eslint-disable-next-line vue/require-prop-types
		unity: {
			required: true
		},
		// eslint-disable-next-line vue/require-default-prop
		inputFixed: {
			type: Object,
			required: false
		},
		simulationType: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			oldData: { ...this.data },
			parcelTypeOptions: JSON.parse(storage.get('parcel_types')),
			interestOptions: [
				{ label: 'Com Juros', value: 'with' },
				{ label: 'Sem Juros', value: 'without' }
			],
			/**
			 * Tipos de parcela que possuem juros opcionais
			 */
			interestAllowed: [
				'unique',
				'monthly',
				'bimonthly',
				'quarterly',
				'four_monthly',
				'semester',
				'yearly',
				'keys',
				'signal',
				'intermediary',
				'assets_rights'
			],
			moneyConfig: {
				decimal: ',',
				thousands: '.',
				prefix: 'R$ ',
				suffix: ' ',
				precision: 2,
				masked: false
			},
			readjustmentOptions: [
				{
					label:'Reajustável',
					value: 'readjustable'
				}, 
				{
					label: 'Fixo',
					value: 'fixed'
				}
			],
			value: ''
		}
	},
	computed: {
		...mapGetters('product', {
			product: 'getProduct'
		}),
		...mapGetters('salesTable', {
			salesTable: 'getSalesTable'
		}),
		/**
		 * Computed property para desabilitar os campos de valor caso nenhum
		 * tipo de parcela ou quota tiverem sido definidos
		 */
		disabled() {
			return !(this.data.parcel_type && this.data.quota)
		},
		/**
		 * Computed property para filtrar os tipos de parcela de modo a ocultar
		 * alguns tipos e formatar seus labels
		 */
		parcelTypeOptionsComputed() {
			/**
			 * Busca nas configurações da etapa 2 do produto quais os tipos de
			 * parcela/série permitidos
			 */
			const productAllowedTypes = this.product &&
				this.product.availability &&
				this.product.availability.infos &&
				this.product.availability.infos.sales_table ?
				this.product.availability.infos.sales_table.parcel_type :
				null
			return this.parcelTypeOptions.map(type => {
					/** Caso o tipo seja permitido, insere um asterisco em seu label */
					if (productAllowedTypes && productAllowedTypes.includes(type.value)) type.label = `${type.label}*`

					return type
				})
				.filter(type => !type.hide)
		},
		/**
		 * Computed property para controlar o valor das parcelas e realizar
		 * os cálculos relacionados a esta propriedade, como o cálculo do
		 * percentual a partir do valor
		 */
		 pmtComputed: {
			get() {
				return this.data.pmt
			},
			set(value) {
				/** Verifica se o valor do campo mudou, e se não foi apenas o efeito da máscara */
				if (parseFloat(this.data.pmt) === value) {
					return;
				}

				if (value && this.data.parcel_type !== 'fixed_value') {
					/**
					 * Calcula o percentual de acordo com o valor informado
					 * e seta a propriedade pmt
					 */
					let unityValue = this.getUnityValueWithDiscount()
					let parcelType = this.facGetFrequency(this.data.parcel_type)
					let rate = this.data.interest === 'with' ?
						parseFloat(this.form.data.monthly_rate) :
						0
					let interest = this.facConvertInterest(rate, parcelType.period)
					let fixedValue = this.getFixedValue()
					/** Remove o valor fixo do valor da unidade  em simulações verticais*/
					if(this.form.data.simulationType === 'horizontal') unityValue -= fixedValue
					
					// eslint-disable-next-line vue/no-mutating-props
					this.data.percent = this.getPercentFromPvWithoutInterest(
						unityValue,
						value,
						interest,
						this.data.quota,
						this.form.data.type
					)
					/** Verifica se o valor informado é 0 */
				} else {
					// eslint-disable-next-line vue/no-mutating-props
					this.data.percent = "0"
				}
				// eslint-disable-next-line vue/no-mutating-props
				this.data.pmt = value;
				this.fixedValueHandler()
			}
		},
		/**
		 * Computed property para controlar o percentual das parcelas e realizar
		 * os cálculos relacionados a esta propriedade, como o cálculo do valor
		 * das parcelas a partir do percentual
		 */
		percentComputed: {
			get() {
				return this.data.percent
			},
				set(value) {
				if (this.data.parcel_type !== 'fixed_value') {
					/**
					 * Calcula o PMT de acordo com a porcentagem digitada
					 * e seta a propriedade percent
					 */
					let unityValue = this.getUnityValueWithDiscount()
					let parcelType = this.facGetFrequency(this.data.parcel_type)
					let rate = this.data.interest === 'with' ?
						parseFloat(this.form.data.monthly_rate) :
						0
					let fixedValue = this.getFixedValue()
					if(parseInt(unityValue) == 0) {
							this.data.pmt = 0
					} 
					/** Remove o valor fixo do valor da unidade  em simulações verticais*/
					if(this.form.data.simulationType === 'horizontal') unityValue -= fixedValue
					// eslint-disable-next-line vue/no-mutating-props
					this.data.pmt = this.getInstallmentPrice(
						unityValue,
						this.form.data.type,
						value / 100,
						rate,
						parcelType.period,
						this.data.quota,
						0
					)
					// eslint-disable-next-line vue/no-mutating-props
					this.data.percent = value
				} else {
					// eslint-disable-next-line vue/no-mutating-props
					this.data.percent = "0"
				}
			}
		},
		/**
		 * Computed property que define a quantidade máxima de uma série/parcela de acordo
		 * com seu tipo
		 */
		maxQuotaComputed() {
			let limit = null
			const frequency = this.facGetFrequency(this.data.parcel_type)
			if (frequency.unique) limit = 1

			return limit
		},
		/**
		 * Computed property que constrói um objeto a partir do data com propriedades
		 * específicas, de modo a serem observadas para identificar mudanças e então
		 * recalcular o valor das parcelas
		 */
		dataObserversComputed() {
			return (({
				parcel_type,
				interest,
				quota,
				due_date,
				type_readjust
			}) => ({
				parcel_type,
				interest,
				quota,
				due_date,
				type_readjust
			}))(this.data)
		},
		/**
		 * Computed property que constrói um objeto a partir do formulário com propriedades
		 * específicas da tabela de vendas, de modo a serem observadas para identificar mudanças
		 * e então recalcular o valor das parcelas
		 */
		salesTableObserversComputed() {
			return (({
				type,
				discount,
				monthly_rate,
				type_readjust
			}) => ({
				type,
				discount,
				monthly_rate,
				type_readjust
			}))(this.form.data)
		}
	},
	/**
	 * Watchers para observar por mudanças no formulário, de modo a refazer os
	 * cálculos das parcelas
	 */
	watch: {
		/**
		 * Identifica mudança na tabela de vendas
		 */
		salesTableObserversComputed: {
			handler() {
				if (this.unity && this.unity.id) this.percentComputed = this.data.percent
			},
			deep: true
		},
		/**
		 * Identifica alteração na unidade selecionada
		 */
		unity: {
			handler() {
				this.percentComputed = this.data.percent
			},
			deep: true
		},
		/**
		 * Identifica alteração na unidade selecionada
		 */
		data: {
			handler() {
				/**
				 * Utiliza o método deepStrictEqual para saber se os dados foram alterados e então
				 * emitir o evento
				 */
				try {
					/** Busca-se apenas as propriedades que se deseja observar */
					let observable = [
						'name',
						'percent',
						'parcel_type',
						'interest',
						'quota',
						'data',
						'sales_table_flow_id',
						'deleted_at',
						'due_date',
						'type_readjust',
						'pmt'
					]
					const data = this.getPropertiesFromObject(this.data, observable)
					const old = this.getPropertiesFromObject(this.oldData, observable)
					assert.deepStrictEqual(data, old)

				} catch (e) {
					this.$emit('change')
					this.oldData = { ...this.data }
				}
			},
			deep: true
		},
		/**
		 * Identifica a inserção de uma série/parcela do tipo Valor Fixo
		 */
		inputFixed: {
			handler(value) {
				/**
				 * Verifica se não é a série/parcela que emitiu o evento,
				 * bem com se não é do tipo Valor Fixo
				 */
				if (this.unity &&
					this.unity.id &&
					this.data.id !== value.id &&
					this.data.parcel_type !== 'fixed_value'
				) this.percentComputed = this.data.percent
			},
			deep: true
		},
		/**
		 * Identifica mudanças em propriedades das quais o valor e percentual
		 * da parcela são dependentes
		 */
		dataObserversComputed: {
			handler() {
				if (this.unity && this.unity.id) this.percentComputed = this.data.percent
			},
			deep: true
		}
	},

	created() {
		this.handleVerticalParcelTypes()
	},

	methods: {
		//Forçando parcelas antigas a serem sem juros em simulações verticais
		//Não há impacto nos calculos, apenas na exibição da etapa
		handleVerticalParcelTypes(){
			if(this.form?.data?.simulationType == 'vertical')
				this.parcelTypeOptionsComputed?.map((item) => {
					if(item.value == this.data.parcel_type){
						this.data.interest = 'without'
					}
					return item
				})
		},
		/**
		 * Calcula o valor da unidade com o disconto, caso haja
		 */
		getUnityValueWithDiscount() {
			let value = 0
			if (this.unity && this.unity.id) {
				value = this.unity.cost
				if (this.form.data.discount) value = this.facValueDiscount(value, this.form.data.discount, 1)
			}

			return value
		},
		/**
		 * Calcula o valor fixo de acordo com as parcelas/séries do tipo Valor Fixo
		 */
		getFixedValue() {
			let value = 0
			for (const item of this.flow.sales_table_item) {
				if (item.parcel_type === 'fixed_value') value += parseFloat(item.pmt) * item.quota || 0
			}

			return value
		},
		/**
		 * Calcula o valor do percentual de uma parcela/série
		 */
		getPercentFromPvWithoutInterest(unityValue, pmt, rate, quota, type) {
			let result = null
			if (rate !== 0) {
				switch (type.toLowerCase()) {
					case 'price':
						result = this.facGetPercentageFromPv(unityValue, pmt, rate, quota)
						break
					case 'sac':
						result = this.facGetPercentageFromPvSac(unityValue, pmt, rate, quota)
						break
					case 'sacoc':
						result = this.facGetPercentageFromPvSacoc(unityValue, pmt, rate, quota)
						break
				}
			} else {
				result = this.facGetPercentFromPvWithoutInterest(unityValue, pmt, quota)
			}

			return result
		},
		/**
		 * Calcula o valor de uma parcela/série
		 */
		getInstallmentPrice(unityValue, type, percent, rate, period, quota, fixedValue) {
			let result = null
			if ((rate > 0) || (rate < 0)) {
				switch (type.toLowerCase()) {
					case 'price':
						result = this.facGetInstallmentPrice((unityValue * percent), rate, period, quota)
						break

					case 'sac':
						result = this.facGetInstallmentSac((unityValue * percent), rate, quota)
						break

					case 'sacoc':
						result = this.facGetInstallmentSacoc((unityValue * percent), rate, quota)
						break
				}

			} else {
				/** Calcula o valor da parcela sem correção */
				result = this.facValueWithoutInterestRate(unityValue, percent, quota, fixedValue)
			}

			return result
		},
		/**
		 * Handler que altera a propriedade interest e name de acordo com o tipo
		 * de parcela selecinado
		 */
		parcelTypeHandler(value) {
			// eslint-disable-next-line vue/no-mutating-props
			if (value === 'fixed_value') this.data.percent = 0
			// eslint-disable-next-line vue/no-mutating-props
			this.data.interest = this.interestAllowed.includes(value) ? 'with' : 'without'
			/** Seta a propriedade nome da série/parcela de acordo com o tipo selecionado */
			const parcel = this.facGetFrequency(value)
			// eslint-disable-next-line vue/no-mutating-props
			if(this.form.data.simulationType === 'vertical'){
				this.data.interest = 'without'
			}
			this.data.name = parcel ? parcel.type : 'Parcela'
		},
		/**
		 * Handler que trata o evento de quando um tipo de taxa for decidido
		 */
		interestHandler() {
			// eslint-disable-next-line vue/no-mutating-props
			if (this.data.parcel_type === 'fixed_value') this.data.percent = 0
		},
		/**
		 * Caso o tipo da parcela selecionado seja Valor Fixo, emite um evento
		 * indicando que uma série/parcela do tipo fixa foi inserida ou removida
		 * e que as outras séries/parcelas devem recalcular seus valores
		 */
		fixedValueHandler() {
			if (this.data.parcel_type === 'fixed_value') {
				this.$emit('input-fixed', { id: this.data.id, value: this.data.pmt })
			}
		},
		/**
		 * Remove o item do banco de dados se já tiver sido cadastrado, ou somente
		 * do fluxo
		 */
		removeItem() {
			if (!this.data.id || String(this.data.id).includes('random')) {
				this.remove()
			} else {
				salesTable.removeItem(this.data.id)
					.then(response => {
						this.remove()
						this.$toastr.s(response.data.msg)
					})
					.catch(error => {
						if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
						console.log('error', error)
					})
			}
		},
		/**
		 * Remove este item do fluxo
		 */
		remove() {
			this.fixedValueHandler()
			this.$emit('remove', this.index)
		},
	},
}
</script>

<style lang="stylus" scoped>
@import './styles.styl';
</style>